import React from 'react';
import { anyDevice } from '../mock';
import { Smartphone, Tablet, Monitor } from 'lucide-react';

export default function AnyDevice() {
  return (
    <section className="section text-white border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-6">
        <div className="flex flex-col items-center text-center gap-8">
          <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="1.2" />
            <circle cx="12" cy="12" r="3" fill="currentColor" />
          </svg>
          <p className="eyebrow">{anyDevice.eyebrow}</p>
          <h2 className="h-display text-[46px] md:text-[64px] leading-[1.02] text-white max-w-[820px]">
            {anyDevice.title}
          </h2>
          <p className="text-white/60 text-[15px] max-w-[520px]">{anyDevice.body}</p>

          <div className="flex items-center gap-10 mt-10 opacity-70">
            <div className="flex flex-col items-center gap-2">
              <Smartphone size={28} strokeWidth={1.3} />
              <span className="mono text-[11px] text-white/55">PHONE</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <Tablet size={28} strokeWidth={1.3} />
              <span className="mono text-[11px] text-white/55">TABLET</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <Monitor size={28} strokeWidth={1.3} />
              <span className="mono text-[11px] text-white/55">DESKTOP</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
